/**
 * Minimal SVG sparkline — pass an array of {top_count} or numeric values.
 * Renders nothing when history is empty; grows as daily snapshots accumulate.
 */
export function Sparkline({ data, width = 120, height = 28 }) {
  const values = (data || []).map((d) => (typeof d === "number" ? d : d.top_count || 0));
  if (values.length < 2) {
    return <div className="text-[10px] text-neutral-600 uppercase tracking-widest">Sparkline builds daily</div>;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = width / (values.length - 1);
  const points = values.map((v, i) => `${(i * stepX).toFixed(1)},${(height - ((v - min) / range) * height).toFixed(1)}`).join(" ");
  const first = values[0];
  const last = values[values.length - 1];
  const rising = last >= first;
  const color = rising ? "#FF3B30" : "#888";
  return (
    <svg data-testid="sparkline" width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="block">
      <polyline points={points} fill="none" stroke={color} strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
